import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Sidebar from "./components/Sidebar";
import VeiculoForm from "./components/VeiculoForm";
import EmConstrucao from "./components/EmConstrucao";
import PaginaSucesso from "./components/PaginaSucesso";
import PaginaSucessoDinamica from "./components/PaginaSucessoDinamica";
import ExclusaoForm from "./components/ExclusaoForm";
import PaginaSucessoExclusao from "./components/PaginaSucessoExclusao";
import AcessoInvalido from "./components/AcessoInvalido";
import Footer from "./components/Footer";

// Este componente organiza o layout principal
const MainLayout = () => {
  const location = useLocation();
  // Pega a página ativa a partir da URL para destacar o link na Sidebar
  const activePage = location.pathname.split("/")[1] || "veiculos";

  return (
    <div className="min-h-screen flex bg-gray">
      <Sidebar activePage={activePage} />
      <div className="flex-1 flex flex-col">
        <main className="flex-grow p-6 md:p-10 overflow-y-auto">
          {/* O <Routes> renderiza o componente correto com base na URL */}
          <Routes>
            <Route
              path="/caso/excluir/sucesso/:hash"
              element={<PaginaSucessoExclusao />}
            />
            <Route path="/caso/excluir/:hash" element={<ExclusaoForm />} />
            <Route path="/caso/:hash" element={<VeiculoForm />} />
            <Route path="/sucesso" element={<PaginaSucesso />} />
            <Route path="/sucesso/:hash" element={<PaginaSucessoDinamica />} />
            <Route path="/veiculos" element={<VeiculoForm />} />
            <Route path="/dashboard" element={<EmConstrucao />} />
            <Route path="/historico" element={<EmConstrucao />} />
            <Route path="/configuracoes" element={<EmConstrucao />} />
            <Route path="*" element={<AcessoInvalido />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </div>
  );
};

// O App principal apenas inicializa o roteador
const App = () => {
  return (
    <Router>
      <MainLayout />
    </Router>
  );
};

export default App;
